module.exports = new __parcel__URL__("Alpha.2ab62991.svg").toString();